
import React, {Component} from 'react';
import KeyboardComponent from "./KeyboardComponent";

class NumericKeyboardComponent extends Component
{
    render()
    {
        return <div style={{marginLeft:'20vw', width:'60vw'}}>
                    <KeyboardComponent onScreenKeyboardContext={this.props.onScreenKeyboardContext}
                                        isShiftOn = {false}
                                        isCapsOn={false}
                                        standardLayout={[
                                                                "1 2 3 {hide}",
                                                                "4 5 6 {bksp}",
                                                                "7 8 9 {ok}",
                                                                ". 0 +"
                                                        ]}
                                        shiftLayout={[]}
                                        capOnLayput={[]}/>
                </div>
    }
}

export default NumericKeyboardComponent;